module.exports = __webpack_public_path__ + "img/register-form-bg.b1f6e00c.webp";